export default __webpack_public_path__ + "static/media/logo.3cbc3bfe.png";